// extracted by mini-css-extract-plugin
export var promotionLink = "_tv-0";